import {useEffect, useState} from 'react'
import axios from '../../Helpers/Api_instance'
import {Formik, Form, Field} from 'formik'
import {KTSVG} from '../../Ihouse/helpers'
import {toast} from 'react-toastify'
import {Modal} from 'bootstrap'

const statuses = [
  'Order Created',
  'Packed',
  'Ready To Pick',
  'Out For Delivery',
  'Completed',
  'Pending',
  'Accepted',
  'Preparing',
]

export default function UpdateOrderStatusModal({id, getOrders, status}) {
  const [initialValues, setInitialValues] = useState({
    status: status,
  })

  const closeModal = (modalId) => {
    const modalElement = document.getElementById(modalId)
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement)
      modalInstance.hide()
    }
  }
  const onSubmit = async (values: any, {resetForm}) => {
    try {
      const res = await axios.patch(`/orders/${id}`, {status: values.status})
      if (res && res.data) {
        getOrders()
        resetForm()
        toast.success('Order Updated Successfully')
        closeModal('order-update')
      }
    } catch (error: any) {
      toast.success('Unable Update Order')
      console.log(error.message)
    }
  }

  useEffect(() => {
    setInitialValues({
      status: status,
    })
  }, [status, id])

  return (
    <div>
      <div className='modal fade' tabIndex={-1} id='order-update'>
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>Update Order</h5>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <KTSVG path='media/icons/duotune/arrows/arr061.svg' />
              </div>
            </div>
            <div className='modal-body'>
              <Formik initialValues={initialValues} enableReinitialize={true} onSubmit={onSubmit}>
                {({}) => (
                  <Form>
                    <div className='fv-row mb-7'>
                      <label className='required fs-6 fw-semibold mb-2'>Status</label>
                      <Field as='select' name='status' className='form-select'>
                        {statuses.map((item: any) => {
                          return <option value={item}>{item}</option>
                        })}
                      </Field>
                    </div>
                    <div className='modal-footer'>
                      <a
                        type='button'
                        className='btn btn-light-danger me-3'
                        data-bs-dismiss='modal'
                      >
                        Close
                      </a>
                      <button type='submit' className='btn btn-light-primary'>
                        Submit
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
